export default "__VITE_ASSET__De0C0OEO__"